module.exports = __webpack_public_path__ + "static/img/nobook.1a66c3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nobook.png
// module id = VfUX
// module chunks = 2